const NOME_TRAVA = 'turbopro:refresh';

interface GerenciadorDeTravas {
  request: <T>(nome: string, callback: () => Promise<T>) => Promise<T>;
}

function travas(): GerenciadorDeTravas | null {
  const nav = globalThis.navigator as (Navigator & { locks?: GerenciadorDeTravas }) | undefined;
  return nav?.locks ?? null;
}

export function travaDisponivel(): boolean {
  return travas() !== null;
}

export async function executarComTrava<T>(tarefa: () => Promise<T>): Promise<T> {
  const gerenciador = travas();
  if (!gerenciador) return tarefa();

  try {
    return await gerenciador.request(NOME_TRAVA, tarefa);
  } catch (falha) {
    if (falha instanceof DOMException) return tarefa();
    throw falha;
  }
}
